<template>
  <div class="account-list">
    <div class="account-list__header">
      <div>{{ $t("message.common.accountType") }}</div>
      <div>{{ $t("message.common.userName") }}</div>
      <div>{{ $t("message.common.actions") }}</div>
    </div>

    <v-expansion-panels>
      <slot name="panels"></slot>
    </v-expansion-panels>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "AccountsExpansionPanelWrapper"
};
</script>
<style lang="scss" scoped>
.account-list {
  &__header {
    display: flex;
    border-bottom: 1px solid $gray-200;
    @include font-size(12px);
    padding: $spacing * 2 $spacing;
    color: $gray-2;
    gap: $spacing;

    div:first-child {
      max-width: 150px;
    }
    div:last-child {
      max-width: 222px;
      width: 100%;
    }
    div {
      flex-grow: 1;
    }
  }
}
</style>
